export const folderToPath = (folderName: string): string => {
  const kebabCase = folderName
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
    .toLowerCase();

  return `/workflows/${kebabCase}`;
};
